export default "__VITE_ASSET__CDAlN66k__"